<div class="box-warning d-flex align-items-center w-100 gap-2">
  <div class="icon-circle flex-shrink-0">
    <svg width="24"
        height="24">
      <use href="assets/images/pictograms/warning-circle-fill-2.svg#warning-circle-fill-2">
      </use>
    </svg>
  </div>

  <div class="flex-grow-1 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
    <div class="flex-grow-1 d-flex flex-column">
      <span class="fw-semibold fs-u1">
        {{'SETTING.OTP.You have not enabled OTP yet.' | translate}}
      </span>
      <span class="color-neutrals-400">
        {{ 'SETTING.OTP.Please enable OTP to sign using a digital signature (Section 26, 28).' | translate }}
      </span>
    </div>
    <button class="btn btn-std-warning btn-std-sm flex-shrink-0"
        [routerLink]="['/', 'profile-detail', 'otp']"
        type="button">
      <span class="fs-base-l2">{{ 'CERTIFICATE.GOTO-OTP-SETTINGS' | translate }}</span>
    </button>
  </div>

  <a class="btn-warning-close fw-semibold fs-u6 p-2 flex-shrink-0"
      href="javascript:void(0)"
      role="button"
      (click)="onClose()">
    <i class="fal fa-times"></i>
  </a>
</div>
